export enum Locale {
    nlBE = "nl_BE",
    frBE = "fr_BE"
}
